import { PaymentType } from '../../enum/payment-type.enum';
import { AttachmentInfo } from '../attachment/attachment-info';
import { Payment, WalletPayment } from './payment';

export class SimplePaymentModel{
  PaymentType: PaymentType;
  constructor(model: WalletPayment) {
    this.PaymentType = model.paymentType;
  }
}

export class PaymentModel extends SimplePaymentModel {
  AttachmentInfo: AttachmentInfo;
  EmailAddress: string;
  BusinessModel: string;
  BankID: string;
  tickerCode: string;
  AttachmentInfoList: AttachmentInfo[];

  constructor(model: Payment) {
    super(model);
    this.PaymentType = model.paymentType;

    if (this.PaymentType === PaymentType.MaybankFPX || this.PaymentType === PaymentType.DuitNow) {
      this.EmailAddress = model.emailAddress;
      this.BusinessModel = model.businessModel;
      this.BankID = model.bankID;
      this.tickerCode = model.tickerCode;
    } else {
      this.AttachmentInfo = model.attachmentInfo;
      this.AttachmentInfoList = model.attachmentInfoList;
    }
  }
}
